<template><div :id="id || null" :class="['collapse', isVisible && 'show']" :aria-hidden="String(!isVisible)"><slot /></div></template>
<script>
import { collapseController } from "./controllers";
import { emitModel } from "./model";
export default {
    name: "SbCollapse",
    emits: ["update:modelValue", "show", "shown", "hide", "hidden"],
    props: {
        id: { type: String, default: null },
        modelValue: { default: undefined },
        visible: { type: Boolean, default: false },
    },
    data() { const value = this.modelValue; return { isVisible: value === undefined ? this.visible : Boolean(value) }; },
    watch: {
        modelValue(value) { if (value !== undefined) { this.setVisible(Boolean(value), false); } },
        visible(value) { if (this.modelValue === undefined) { this.setVisible(value, false); } },
    },
    mounted() { collapseController.register(this.id, this); collapseController.notify(this.id, this.isVisible); },
    beforeUnmount() { collapseController.unregister(this.id, this); },
    methods: {
        show() { this.setVisible(true); }, hide() { this.setVisible(false); }, toggle() { this.setVisible(!this.isVisible); },
        setVisible(visible, emit = true) {
            if (visible === this.isVisible) { return; }
            this.$emit(visible ? "show" : "hide");
            this.isVisible = visible;
            if (emit) { emitModel(this, visible); }
            collapseController.notify(this.id, visible);
            this.$nextTick(() => this.$emit(visible ? "shown" : "hidden"));
        },
    },
};
</script>
